import type { ReactElement } from 'react';
import { Link } from '@chakra-ui/react';
import { classNames } from '../../../utils/tailwind/classNames';

export type SlideItemProps = {
    testId: string;
    image?: string;
    title: string;
    chef: string;
    price: string;
    buttonTo?: string;
    buttonText?: string;
};

export const SlideItem = ({
    testId,
    image,
    title,
    chef,
    price,
    buttonTo,
    buttonText,
}: SlideItemProps): ReactElement => (
    <div
        aria-label="slider-item"
        data-testid={testId}
        className={classNames(
            'flex h-full w-full flex-col justify-between border border-slt-pepper-1000 bg-cover bg-center p-4',
            'relative rounded-[1.125rem] before:pointer-events-none before:absolute before:inset-0 before:rounded-[1.125rem] before:bg-gradient-to-t before:from-transparent before:to-black/50 before:content-[""]',
        )}
        style={{ backgroundImage: image ? `url(${image})` : undefined }}
    >
        <div className="relative z-10 flex flex-col gap-2">
            <h4 className="leading-12 text-2xl font-medium text-white sm:text-[2rem]">{title}</h4>
            <p className="text-base font-medium leading-6 text-white">{chef}</p>
            <p className="text-base font-medium leading-6 text-white">{price}</p>
        </div>
        {!!buttonTo && (
            <Link
                href={buttonTo}
                display="inline-flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="md"
                border="1px"
                borderColor="slt-pepper-1000"
                bg="white"
                px="8"
                py="2"
                fontSize="base"
                fontWeight="medium"
                textTransform="uppercase"
                color="slt-pepper-1000"
                textDecoration="none"
                position="relative"
                zIndex="10"
                transition="opacity 0.3s ease"
                className="pointer-cursor opacity-0 transition-opacity duration-300 group-[.swiper-slide-active]:opacity-100"
                title={title}
                data-testid={`slide-item-${testId}-button`}
                _hover={{
                    textDecoration: 'none',
                }}
            >
                {buttonText}
            </Link>
        )}
    </div>
);

SlideItem.defaultProps = {
    image: undefined,
    buttonTo: undefined,
    buttonText: undefined,
};
